import React, { useState } from "react";
import AuthLayout from "./AuthLayout";
import borderBack from "../../../assets/images/borderBack.png";
import MainButton from "../../shared/Button";
import { Formik, Form, Field } from "formik";
import AuthInput from "../../shared/authinput";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import FormMainLayouts from "../../layouts/FormMainLayouts";
import { RESETPASSWORD } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { ChangePasswordvalidation } from "../../../helpers/validations/Auth";
import { useSearchParams } from "react-router-dom";
import { Header, Linked, Maincontant } from "./styles/ChangePasswordStyle";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const ResetToken = searchParams.get("token");

  const handleSubmit = async (values, { resetForm }) => {
    const { newPassword } = values;

    try {
      setLoading(true);
      const resp = await httpRequest.post(RESETPASSWORD, {
        user: { reset_password_token: ResetToken, password: newPassword },
      });
      if (resp?.status === 200) {
        toast.success(resp?.data?.message);
        navigate("/password-success");
        resetForm();
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        (error?.response?.data?.message || "Something went wrong").replace(
          "Validation failed: ",
          ""
        )
      );
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg">
      <AuthLayout arrow={true}>
        <Header>
          <Linked to={-2}>
            <img src={borderBack} alt="Linkarrow" />
          </Linked>
          <Maincontant>
            <h6>New Credentials</h6>
            <p>Password must be at least 8 characters long.</p>
            <p>Password must contain at least one upper case.</p>
            <p>One lower case letter.</p>
            <p style={{ marginBottom: "40px" }}>
              Password must contain at least one number or special character.
            </p>
          </Maincontant>
        </Header>
        <Maincontant className="showonMobile">
          <p>Password must be at least 8 characters long.</p>
          <p>Password must contain at least one upper case.</p>
          <p>One lower case letter.</p>
          <p style={{ marginBottom: "40px" }}>
            Password must contain at least one number or special character.
          </p>
        </Maincontant>
        <FormMainLayouts>
          <Formik
            initialValues={{ newPassword: "", confirmPassword: "" }}
            validationSchema={ChangePasswordvalidation}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form autocomplete="off">
                <Field
                  type="password"
                  name="newPassword"
                  label="New Password"
                  component={AuthInput}
                  placeholder="Enter your password"
                  maxLength={10}
                  showIcon={true}
                />
                <Field
                  type="password"
                  name="confirmPassword"
                  label="Confirm Password"
                  component={AuthInput}
                  placeholder="Confirm your password"
                  maxLength={10}
                  showIcon={true}
                />

                <MainButton
                  type="submit"
                  label="Send"
                  MT="100"
                  isLoading={Loading}
                />
                <MainButton
                  type="button"
                  label="Cancel"
                  border={true}
                  MT="15"
                  onClick={() => navigate("/login")}
                />
              </Form>
            )}
          </Formik>
        </FormMainLayouts>
      </AuthLayout>
    </Container>
  );
};

export default ChangePassword;
